import News from '../sections/news/News';
import App from '../App';

window.App = App;
window.Section = News;


